import baseApi from "../../../common/api/baseApi";

const authHeaders = () => ({
  headers: { token: localStorage.getItem("token") }
});

/**
 * 보관함 목록 조회.
 * 응답: { result: { retCode, retMsg }, carts: [{ cartSeq, bookName, regDt }] }
 */
export const getCartList = () => {
  return baseApi
    .get("/book/cart/list", authHeaders())
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

/**
 * 보관함 담기 — 도서 제목만 저장.
 * URL/가격은 외부 사이트 데이터라 언제든 바뀌므로 보관하지 않고,
 * 신청할 때 다시 검색해서 현재 정보로 고른다.
 *
 * @param {Array<string>} bookNames
 */
export const addToCart = bookNames => {
  return baseApi
    .post(
      "/book/cart/add",
      { books: bookNames.map(name => ({ bookName: name })) },
      authHeaders()
    )
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

/**
 * 보관함 항목 삭제.
 *
 * @param {number} cartSeq
 */
export const deleteCartItem = cartSeq => {
  return baseApi
    .post("/book/cart/delete", { cartSeq }, authHeaders())
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};
